export const PIPEFY_FAILURE_CANCELLATION_MESSAGES: Record<string, string> = {
  PIPEFY_IMPORT_FAILED_CARDS_CANCELLED: 'O envio ao Pipefy falhou. Todos os cards criados nessa tentativa foram cancelados automaticamente. Revise o briefing antes de reenviar.',
  PIPEFY_IMPORT_FAILED_CANCELLATION_PENDING: 'O envio ao Pipefy falhou. O sistema está verificando e cancelando os cards dessa tentativa. Aguarde a conclusão antes de reenviar.',
  PIPEFY_IMPORT_FAILED_CANCELLATION_ERROR: 'O envio ao Pipefy falhou e o cancelamento dos cards ainda não foi concluído. O sistema tentará novamente. O reenvio está bloqueado para evitar duplicação.',
};

export function hasPendingPipefyFailureCancellation(error?: string): boolean {
  return error === 'PIPEFY_IMPORT_FAILED_CANCELLATION_PENDING'
    || error === 'PIPEFY_IMPORT_FAILED_CANCELLATION_ERROR';
}
